"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleFieldTemplate = void 0;
const react_1 = __importDefault(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const styled_components_1 = __importDefault(require("styled-components"));
const Title = (0, styled_components_1.default)(wl_ui_kit_1.FormLabel) `
  margin-bottom: ${(0, wl_ui_kit_1.getSizeBy)(4)};
`;
const TitleFieldTemplate = ({ title }) => {
    return react_1.default.createElement(Title, null, title);
};
exports.TitleFieldTemplate = TitleFieldTemplate;
//# sourceMappingURL=title-field-template.js.map